import ValidClaimHeader from "./ValidClaimHeader"

export default ValidClaimHeader
